/**
 * Media URL resolver (Bloc 2 - 2026-08-21).
 *
 * Regle stricte : le frontend public ne DOIT JAMAIS afficher l'`original_cloudinary_url`
 * (le master). Il DOIT prioriser `public_cloudinary_url` (watermarke, floute, etc.),
 * puis retomber sur `cloudinary_url` (compat retro Photos), puis sur `image_data` (base64).
 *
 * `getAdminMediaUrl` peut retourner le master si necessaire (page de comparaison
 * Master vs Public dans /dashboard/media/{id}).
 */

function _fromCloudinaryLike(obj) {
  if (!obj || typeof obj !== "object") return null;
  return (
    obj.public_cloudinary_url ||
    obj.cloudinary_url ||
    (obj.image_data ? `data:image/jpeg;base64,${obj.image_data}` : null) ||
    null
  );
}

/**
 * Resolve the PUBLIC-safe URL for a media/photo object.
 * Accepts: Media doc, Photo doc, plain URL string, null.
 * Never returns `original_cloudinary_url` unless it is the only URL present
 * (fallback for very old records where public was never computed).
 */
export function getPublicMediaUrl(input) {
  if (!input) return null;
  if (typeof input === "string") return input;

  const primary = _fromCloudinaryLike(input);
  if (primary) return primary;

  // Ultime fallback : master (records legacy). On preserve la fonctionnalite
  // mais aucun master ne devrait rester sans public en production.
  if (input.original_cloudinary_url) return input.original_cloudinary_url;
  return null;
}

/**
 * Admin URL : master d'origine si dispo, sinon public. A n'utiliser que dans le
 * back-office (MediaDetail comparateur, editeur floutage sur canvas).
 */
export function getAdminMediaUrl(input) {
  if (!input) return null;
  if (typeof input === "string") return input;
  return input.original_cloudinary_url || _fromCloudinaryLike(input);
}

/**
 * Best-effort thumbnail via Cloudinary transforms on the PUBLIC url only.
 * Preserve les watermark/blur transformations existantes (elles sont apres /upload/ deja).
 */
export function getPublicThumbnail(input, size = 400) {
  const url = getPublicMediaUrl(input);
  if (!url) return null;
  if (!url.includes("cloudinary.com") || !url.includes("/upload/")) return url;
  if (url.startsWith("data:")) return url;
  // Insere le resize APRES /upload/ mais avant les autres transforms deja presents
  return url.replace(
    "/upload/",
    `/upload/c_fill,g_auto,w_${size},h_${size},q_auto/`
  );
}

export default { getPublicMediaUrl, getAdminMediaUrl, getPublicThumbnail };
